import { render, staticRenderFns } from "./authdiolg.vue?vue&type=template&id=8e201354&scoped=true&"
import script from "./authdiolg.vue?vue&type=script&lang=js&"
export * from "./authdiolg.vue?vue&type=script&lang=js&"
import style0 from "./authdiolg.vue?vue&type=style&index=0&id=8e201354&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e201354",
  null
  
)

export default component.exports